import { Radio } from 'antd';
import React from 'react';
import { useStore } from 'zustand';

import { amplitudeTrack } from 'app/utils/track/amplitude';

import { inventoryStore } from '../../../../InventoryStore';

export enum PackType {
  NIGHT_STAY = 'NIGHT_STAY',
  DAYTIME = 'DAYTIME',
}

export enum ExperienceInventoryType {
  DAILY_STOCK = 'DAILY_STOCK',
  TIME_SLOTS = 'TIME_SLOTS',
}

export type ToggleValue = PackType | ExperienceInventoryType;

export type InventoryToggleOption = {
  label: string;
  value: ToggleValue;
};

export type InventoryToggleProps = {
  value: ToggleValue;
  onChange?: (value: ToggleValue) => void;
  options: InventoryToggleOption[];
  className?: string;
};

export const InventoryToggle: React.FC<InventoryToggleProps> = ({
  value,
  onChange,
  options,
  className = '',
}) => {
  const isEditMode = useStore(inventoryStore, (state) => state.isEditMode);
  const tab = useStore(inventoryStore, (state) => state.tab);

  return (
    <Radio.Group
      options={options.map((option) => ({
        label: option.label,
        value: option.value,
        disabled: isEditMode && option.value !== value,
      }))}
      onChange={(e) => {
        onChange && onChange(e.target.value);
        amplitudeTrack('Click Inventory tab', {
          tab: tab.name,
          tabType: e.target.value,
        });
      }}
      value={value}
      optionType="button"
      className={className}
    />
  );
};
